import React from 'react';
import styled from 'styled-components';
import { Text } from 'components/styled/ui';
import { strings } from 'config';


const getSubCategories = subcategories => {

  const selectedLang = strings.getLanguage();  
  
  if (subcategories.length) {
    return (
      <ul className="sub-categories">
        {subcategories.map((val, index) => <li key={index}>{ selectedLang === 'en' ?  val.title : val.title_ne }</li>)}
      </ul>
    );
  }
};

const CategoriesText = ({ categories, subcategories }) => {

  const selectedLang = strings.getLanguage();  

  return (
    <Content className="categories-list" lang={strings.getLanguage()}>
      {categories.length > 0 ? (
        categories.map((val, index) => (
          <li key={index}>
            <Text.span>{ selectedLang === 'en' ?  val.title : val.title_ne}</Text.span>
            {getSubCategories(val.subcategory)}
          </li>
        ))
      ) : (
        <span className="no-data">-</span>
      )}
    </Content>
  );
};

export default CategoriesText;

const Content = styled.ul`
  // margin-bottom: 10px;
  line-height: 1.4;

  > li {
    display: block;
    
    span{
     font-size: ${props => props.lang === 'en' ? '14px' : '16px'}; 
    }

    >span{
      margin-right: 8px;
    }

    &:not(:last-child) {
      margin-bottom: 4px;
      // &:after {
      //   content: ',';
      //   margin-right: 4px;
      // }
    }

    .sub-categories {
      display: block;
      color: rgba(74, 74, 74, .5); 
      
       li {
        display: inline-block;
        &:first-child{
          &:before{
            content: '('
          }
        }
        &:last-child{
          &:after{
            content: ')'
          }
        }
        &:not(:last-child){
          &:after{
            content: ',';
            margin-right: 3px;
          }
        }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/categoriesText/categoriesText.js